import { buildI18nInjectionToken } from '@pct-ng/transloco';

const I18nScope = 'core/auth/ui';
export const I18nProviderInjectionToken = buildI18nInjectionToken(I18nScope);
